import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';

const Row = ({ cutoff, onRemove, onUpdate }) => (
    <tr>
        <td>{cutoff.affids}</td>
        <td>{cutoff.country}</td>
        <td>{cutoff.base}</td>
        <td>{cutoff.weekend}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle={'info'} onClick={() => onUpdate(cutoff)}>Update</Button>
                <Button bsStyle={'danger'} onClick={() => onRemove(cutoff.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>
);

export default Row;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/Affid/components/Table/components/Row/index.js